// src/config/menuConfig.js
//
// FONTE ÚNICA das páginas internas da Intranet.
// Usada por: menu lateral (Sidebar), tela de Acessos (ManageAccessPage) e permissões automáticas do admin (App.js).
//
// Para adicionar uma página nova:
//   1. Inclua a chave em PAGES (nome no menu, nome na tela de Acessos e ícone).
//   2. Coloque a chave no grupo desejado em MENU_SECTIONS (ou ADMIN_SECTION, se não tiver item no menu).
//   3. Inclua a chave em PERMISSIONS_CONFIG (permissionsConfig.js) com níveis e itens de tela.
//   4. Crie o `case` correspondente em MainContent.js.

export const PAGES = {
    'home': {
        label: 'Clientes',
        accessLabel: 'Início / Dashboard',
        icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
    },
    'tickets': {
        label: 'Chamados',
        accessLabel: 'Chamados (Tickets)',
        icon: 'M15 5v2m0 4v2m0 4v2M5 5a2 2 0 012-2h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5z'
    },
    'asset-management': {
        label: 'Gestão de Ativos',
        accessLabel: 'Gestão de Ativos',
        icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
    },
    'client-contracts': {
        label: 'Clientes Contrato',
        accessLabel: 'Clientes Contrato',
        icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
    },
    'client-one-off': {
        label: 'Clientes Avulsos',
        accessLabel: 'Clientes Avulsos',
        icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
    },
    'financeiro': {
        label: 'Cobranças',
        accessLabel: 'Financeiro: Cobranças',
        icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z'
    },
    'wiki': {
        label: 'Wiki Técnica',
        accessLabel: 'Wiki Técnica',
        icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
    },
    'passwords': {
        label: 'Cofre de Senhas',
        accessLabel: 'Cofre de Senhas',
        icon: 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z'
    },
    'acesso-remoto': {
        label: 'Acesso Remoto',
        accessLabel: 'Acesso Remoto',
        icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
    },
    'technical-reports': {
        label: 'Laudos Técnicos',
        accessLabel: 'Laudos Técnicos',
        icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
    },
    'service-values': {
        label: 'Tabela de Preços',
        accessLabel: 'Tabela de Preços',
        icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
    },
    'avisos': {
        label: 'Avisos & Alertas',
        accessLabel: 'Avisos & Alertas',
        icon: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9'
    },
    'contracts': {
        label: 'Gestão de Contratos',
        accessLabel: 'Gestão de Contratos',
        icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
    },

    // --- Páginas sem item nos grupos do menu ---
    'manage-access': {
        label: 'Acessos',
        accessLabel: 'Gerenciar Acessos',
        icon: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4'
    },
    'manage-ticket-info': { label: 'Campos de Chamados', accessLabel: 'Config: Campos de Chamados' },
    'ai-search': { label: 'Busca com IA', accessLabel: 'Busca com IA' }
};

// Grupos do menu lateral (na ordem em que aparecem). label: null = grupo principal, sem título.
export const MENU_SECTIONS = [
    { id: 'principal', label: null, items: ['home', 'tickets', 'asset-management'] },
    { id: 'cadastros', label: 'Cadastros', items: ['client-contracts', 'client-one-off'] },
    { id: 'financeiro', label: 'Financeiro', items: ['financeiro'] },
    { id: 'utilitarios', label: 'Utilitários', items: ['wiki', 'passwords', 'acesso-remoto', 'technical-reports', 'service-values', 'avisos', 'contracts'] }
];

// Páginas administrativas (aparecem na tela de Acessos, mas não nos grupos do menu)
export const ADMIN_SECTION = { id: 'administracao', label: 'Administração', items: ['manage-access', 'manage-ticket-info', 'ai-search'] };

// Lista para a tela de Acessos, já agrupada: [{ id, label, section }]
export const ACCESS_PAGES = [...MENU_SECTIONS, ADMIN_SECTION].flatMap(section =>
    section.items.map(id => ({ id, label: PAGES[id]?.accessLabel || id, section: section.label || 'Principal' }))
);

// Chaves legadas que continuam recebendo permissão do admin (compatibilidade)
const LEGACY_KEYS = ['manage-ticket-clients'];

// Todas as chaves técnicas (admin recebe 'edit' em todas automaticamente)
export const ALL_PAGE_KEYS = [...new Set([...ACCESS_PAGES.map(p => p.id), ...LEGACY_KEYS])];
